<template>
  <div>
    <loading :active.sync="isLoading" background-color="#D0D0D0	">
      <div class="loadingio-spinner-eclipse-y24d302hfm">
        <div class="ldio-f9ujl5oazv5">
          <div></div>
        </div>
      </div>
    </loading>

    <div v-if="show">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      isLoading: true,
      show: false,
      access_token: "",
    };
  },

  metaInfo: {
    htmlAttrs: {
      lang: "en",
    },

    meta: [
      {
        name: "description",
        content:
          "Chan Chao International Enterprise Group was founded in October, 1985 and is the first civil professional exhibition corporation. We are engaged in organizing large-scale international exhibitions and conferences, publishing exhibition magazine and CD-title, deputizing digital online exhibition.",
      },
      {
        name: "keywords",
        content:
          "Chan Chao Exhibition Hall,chanchao,Exhibition Organizer,Directory publication,Web design,Internet Marketing,Advertisements,Taipei world trade center,TWTC,Machine tool,Mold & Die,Automation,Food show,Tibs,Coffee show,Pet show,Textile,Asia Machinery,Asia Machinery Buyers Guide,Linkage,Vietnam,HCM,Hanoi,Dhaka Bangladesh,Suzhou,Cambodia,Logistics & AUTOID,www.chanchao.com,www.chanchao.com.tw,chanchao",
      },

      {
        name: "apple-mobile-web-app-title",
        content: "បណ្តាញពិព័រណ៍ Chan Chao",
      },

      {
        name: "application-name",
        content: "បណ្តាញពិព័រណ៍ Chan Chao",
      },
    ],
  },

  created() {
    //驗證是否為登入狀態

    const vm = this;
    let nowPage = location.href;
    let activePage = nowPage.split("/")[5];
    // // console.log(activePage)

    //取cookie
    // vm.access_token = vm.$cookies.get('as')

    if (activePage !== "logout") {
      const url = "https://www.chanchao.com.tw/apiLogin2/isAuthenticated";
      const info = null;

      vm.$http.post(url, info).then(function (response) {
        if (response.data == 200) {
          sessionStorage.setItem("access", "200");
          // // console.log('accesstoken正確未過期')

          let lastPage = document.referrer;
          let lastdomain = lastPage.split("/")[2];
          let noAccounts = lastPage.split("/")[3]; //排除網址有accounts

          if (
            lastdomain == "www.chanchao.com.tw" &&
            noAccounts !== "accounts" &&
            noAccounts !== "accounts"
          ) {
            if (activePage == "forgetPw" || activePage == "resetPw") {
              vm.isLoading = false;
              vm.show = true;
            } else {
              alert("បច្ចុប្បន្ន អ្នក​បាន​ចូល");

              //如果網域為展昭
              document.location.href = lastPage; //問題點
            }
          } else {
            //因重設密碼有設參數，因此擷取?前面的字串為判斷
            let activePage2 = activePage.split("?")[0];

            if (activePage2 == "signup") {
              alert("បច្ចុប្បន្ន អ្នក​បាន​ចូល");
              document.location.href = "https://www.chanchao.com.tw/en/member/";
            } else if (activePage2 == "forgetPw" || activePage2 == "resetPw") {
              vm.isLoading = false;
              vm.show = true;
            } else {
              alert("បច្ចុប្បន្ន អ្នក​បាន​ចូល");
              document.location.href = "https://www.chanchao.com.tw/en/";
            }
          }
        } else if (response.data == 250) {
          const url = "https://www.chanchao.com.tw/apiLogin2/refresh";
          vm.$http.post(url).then(function (response) {
            if (response) {
              vm.isLoading = false;
              vm.show = true;

              sessionStorage.setItem("access", "200");
            } else {
              vm.isLoading = false;
              vm.show = true;
              sessionStorage.setItem("access", "");
              sessionStorage.removeItem("access");
            }
          });
        } else {
          vm.isLoading = false;
          vm.show = true;
          sessionStorage.setItem("access", "");
          sessionStorage.removeItem("access");
        }
      });
    } else {
      vm.isLoading = false;
      vm.show = true;
    }
  },
};
</script>

<style lang="scss">
@keyframes ldio-f9ujl5oazv5 {
  0% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ldio-f9ujl5oazv5 div {
  position: absolute;
  animation: ldio-f9ujl5oazv5 1s linear infinite;
  width: 160px;
  height: 160px;
  top: 20px;
  left: 20px;
  border-radius: 50%;
  box-shadow: 0 4px 0 0 #777b7c;
  transform-origin: 80px 82px;
}
.loadingio-spinner-eclipse-y24d302hfm {
  width: 200px;
  height: 200px;
  display: inline-block;
  overflow: hidden;
}
.ldio-f9ujl5oazv5 {
  width: 100%;
  height: 100%;
  position: relative;
  transform: translateZ(0) scale(1);
  backface-visibility: hidden;
  transform-origin: 0 0; /* see note above */
}
.ldio-f9ujl5oazv5 div {
  box-sizing: content-box;
}

@media (min-width: 991px) {
  .PcDevice_block {
    display: block;
  }

  .MbDevice_block {
    display: none;
  }

  .MbDevice_inline {
    display: none;
  }
}

@media (max-width: 991px) {
  .PcDevice_block {
    display: none;
  }

  .MbDevice_block {
    display: block;
  }

  .MbDevice_inline {
    display: inline;
  }
}
</style>
